import { Box, FormControlLabel, Switch } from '@mui/material';

import { useLightMode } from './contexts/LightModeContext';

export const LightModeSwitch = () => {
  const { isLightMode, setIsLightMode } = useLightMode();
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5
      }}
    >
      <FormControlLabel
        control={
          <Switch
            checked={!isLightMode}
            onChange={() => {
              setIsLightMode(prevLightMode => !prevLightMode);
            }}
          />
        }
        label={isLightMode ? 'Light mode' : 'Dark mode'}
        labelPlacement='start'
        sx={{ mt: 1, fontWeight: 500 }}
      />
    </Box>
  );
};
